<template>
    <Drawer
        width="1024"
        placement="right"
        :closable="false"
        :visible="visible"
        v-bind="$attrs"
        v-on="$listeners"
        @close="close"
    >
        <div
            slot="title"
            class="flex items-center justify-between"
        >
            {{ $t('customerAccess') }}
            <AntButton
                type="primary"
                @click="save"
            >
                {{ $t('save') }}
            </AntButton>
        </div>
        <Spin :spinning="!hasFetched">
            <CustomerTransfer
                :access="access"
                :customers="customers"
                @on-change="change"
            />
        </Spin>
    </Drawer>
</template>

<script>
import CustomerTransfer from './CustomerTransfer';
import { Button, Spin } from 'ant-design-vue';
import drawerMixin from '@/mixins/drawerMixin';
import { mapActions } from 'vuex';

export default {
    name: 'CustomerAccessDrawer',
    components: {
        Spin,
        CustomerTransfer,
        AntButton: Button,
    },
    mixins: [drawerMixin],
    props: {
        measureId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            customers: [],
            access: [],
            selectedCustomers: [],
            hasFetched: false,
        };
    },
    created() {
        this.$on('show', async () => {
            if (this.hasFetched) {
                return;
            }

            this.customers = await this.$http.get('customers');
            this.access = await this.$http.get(`measures/${this.measureId}/customer-access`);
            this.hasFetched = true;
        });
    },
    methods: {
        ...mapActions({
            updateCustomerAccess: 'measures/updateCustomerAccess',
        }),
        change(customers) {
            this.selectedCustomers = customers;
        },
        async save() {
            this.close();

            await this.updateCustomerAccess(this.selectedCustomers);

            this.$notification.success({
                message: this.$t('entitySaved', {
                    entity: this.$t('customerAccess'),
                }),
            });
        },
    },

};
</script>

<style>

</style>